import React from 'react';

import { useTranslation } from 'react-i18next';

import { colors } from 'constants-colors';
import { imageUrl } from 'lane-shared/helpers/formatters';

import { ErrorMessage, Loading } from 'components/general';
import { Button } from 'design-system-web';
import { Modal } from 'components/lds';
import { H4, M } from 'components/typography';

import channelImageDefault from 'static/img/channel-image-default.svg';

import { useInviteContext } from 'lane-shared/contexts/InviteContext';
import styles from './InviteModal.scss';

export function InviteModal() {
  const { t } = useTranslation();
  const {
    inviteId,
    company,
    building,
    loading,
    clearInvite,
    claiming,
    claimError,
    claimInvite,
  } = useInviteContext();

  const channel = company || building;

  async function acceptInvite() {
    if (inviteId && channel?._id) {
      const data = await claimInvite(inviteId, channel._id);

      if (data) {
        clearInvite();
      }
    }
  }

  const JoinButton = (
    <Button
      className={styles.joinButton}
      variant="primary"
      type="button"
      loading={claiming}
      onClick={acceptInvite}
    >
      {t('Join community')}
    </Button>
  );

  if (loading) {
    return <Loading />;
  }

  return (
    <Modal
      className={styles.inviteModal}
      onClose={clearInvite}
      isOpen={Boolean(inviteId)}
      actions={JoinButton}
    >
      <div className={styles.inviteInfo}>
        <div
          className={styles.channelImage}
          style={{
            backgroundImage: `url(${imageUrl(
              channel?.profile?.image || channelImageDefault
            )})`,
            backgroundSize: channel?.profile?.image ? 'cover' : '45em',
          }}
        >
          <div
            className={styles.channelIcon}
            style={{
              backgroundImage: `url(${imageUrl(channel?.profile?.logo)})`,
              backgroundColor: channel?.profile?.logo
                ? colors.white
                : colors.laneGreen,
            }}
          />
        </div>
        <div className={styles.channelInfo}>
          <H4 v2>{channel?.name}</H4>
          <M className={styles.channelAddress}>{channel?.address?.street1}</M>
          <ErrorMessage error={claimError} />
        </div>
      </div>
    </Modal>
  );
}
